import React, { useContext } from "react";
import { Checkbox } from "antd";

import Style from "../questionItem.module.scss";
import { previewExamContext } from "../../../context";
import { isTrue } from "../../../../../../service/service";

interface IProps {
    homeworkState: number;
    list: {
        answerId: number;
        content: string;
        isChoose: "0" | "1";
        isRight: "0" | "1";
    }[];
    onChange: (value: number[]) => void;
}

export const Multiple = ({ list, homeworkState, onChange }: IProps) => {
    const handleChange = (values: any[]) => {
        if (homeworkState === 2) return;
        onChange(values);
    };

    const { showAnswer } = useContext(previewExamContext);

    return (
        <Checkbox.Group onChange={handleChange}>
            {list.map(item => (
                <div key={item.answerId} className={Style.option}>
                    <Checkbox
                        className={
                            homeworkState === 2 && item.isRight === "1"
                                ? Style.success
                                : undefined
                        }
                        value={item.answerId}>
                        <div
                            className={Style.displayinlineblock}
                            dangerouslySetInnerHTML={{ __html: item.content }}
                        />
                        {showAnswer && isTrue(item.isRight) && (
                            <span className={Style.success}>正确答案</span>
                        )}
                    </Checkbox>
                </div>
            ))}
        </Checkbox.Group>
    );
};
